import React from "react";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import PropTypes from "prop-types";
import ObjectOverride from "components/ObjectOverride";

/**
 *  @property {Customers_Emails_Object} state
 *  @property {object} model
 *  @property {Customers_Emails_Properties} model.properties
 *  @property {Customers_Emails_Is} model.is
 *  @property {Customers_Emails_Has} model.has
 */
export default class CustomerEmail extends ObjectOverride {
	static propTypes = {
		...super.PropTypes,
		email: PropTypes.object,
	};

	constructor(props) {
		super(props, Types.Customers_Emails._name);
	}

	// noinspection JSUnusedGlobalSymbols
	loadSelf = async () => {
		let data = this.props.email;

		if (!data) return;

		let newState = {
			loading: false,
			loaded: true,
		};

		if (this._ismounted) {
			this.model.properties.forEach((item, key) => {
				if (item && typeof data[key] !== 'undefined') {
					newState[key] = data[key];
				}
			});

			this.model.has.forEach((item, key) => {
				if (item && typeof data[key] !== 'undefined') {
					newState[key] = data[key];
				}
			});

			this.model.is.forEach((item, key) => {
				if (item && typeof data[key] !== 'undefined') {
					newState[key] = data[key];
				}
			});

			this.setState(newState, () => this.loadSelfAfter(data))
		}

		this.loadSelfAfterAlways();
	};

	form = () => {
		/** @type {Customers_Emails_Properties} properties */
		let properties = this.model.properties;
		/** @type {Customers_Emails_Object} object */
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset>
					<h4 className="section-title">Email</h4>
					<div className="form-group">
						<Framework.Elements.EmailAddress
							property={properties.email}
							value={object.email}
							error={object.email_error}
							update={this.handleTextFieldPropertyUpdate}
						/>
					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	};


}
